import { useWebsiteUpdatesBanner } from '@consumer-frontend/nc-api';
import { Icon } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/header.scss';

export const NcWebsiteUpdatesBanner: React.FC = () => {
  const [isOpen, setIsOpen] = useWebsiteUpdatesBanner(); // this is the IRL use case

  if (!isOpen) return null;

  const handleClose = () => setIsOpen(false);

  return (
    <div className="website-updates-banner">
      <div className="message">
        <span className="bold-text">Website updates in progress.</span>
        <span> Things may look different as we improve your experience.</span>
      </div>
      <button aria-label="Close" type="button" onClick={handleClose}>
        <Icon iconName="x-lg" />
      </button>
    </div>
  );
};
